/* Vilkårssidene. Se gs-vilkar.css for hva som er målt og hvorfor.
 *
 * Endrer aldri teksten i dokumentene. Legger bare til klasser, id-er og en
 * innholdsfortegnelse. Shopify eier markupen på /policies/*, så dette er
 * eneste måten å gi dem struktur på uten å røre de juridiske tekstene.
 */
(() => {
  const beholder = document.querySelector('.shopify-policy__container');
  const rte = beholder && beholder.querySelector('.shopify-policy__body .rte');
  if (!rte) return;

  const tittel = beholder.querySelector('.shopify-policy__title h1');
  const renset = (s) => (s || '').replace(/\s+/g, ' ').trim();
  const erVersaler = (s) => /\p{L}/u.test(s) && s === s.toLocaleUpperCase('nb-NO');

  // Stikktittel over tittelen.
  if (tittel && !beholder.querySelector('.gs-vilkar__stikk')) {
    const stikk = document.createElement('span');
    stikk.className = 'gs-eyebrow gs-vilkar__stikk';
    stikk.textContent = 'Kundeservice';
    tittel.parentNode.insertBefore(stikk, tittel);
  }

  // Den ekstra h1-en inni teksten.
  rte.querySelectorAll('h1').forEach((h) => {
    if (tittel && renset(h.textContent).toLocaleLowerCase('nb-NO') === renset(tittel.textContent).toLocaleLowerCase('nb-NO')) {
      h.classList.add('gs-vilkar__dobbel');
    }
  });

  // Mellomtitler: ekte overskrifter, og avsnitt som bare består av fet tekst
  // (personvernerklæringen: <p><strong>Nyhetsbrev:</strong></p>).
  const titler = [];
  rte.querySelectorAll('h2, h3, h4, h5, h6, p').forEach((el) => {
    const tekst = renset(el.textContent);
    if (!tekst) return;
    if (el.tagName === 'P') {
      const fet = el.querySelector(':scope > strong, :scope > b');
      if (!fet || renset(fet.textContent) !== tekst || tekst.length > 90) return;
      el.classList.add('gs-vilkar__mellomtittel');
    }
    if (erVersaler(tekst)) el.classList.add('gs-versaler');
    titler.push({ el, tekst });
  });

  if (titler.length < 5) return;

  const brukt = new Set();
  const slug = (s) => {
    let base = s.toLocaleLowerCase('nb-NO')
      .replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'del';
    let id = base, n = 2;
    while (brukt.has(id) || document.getElementById(id)) id = `${base}-${n++}`;
    brukt.add(id);
    return id;
  };
  const setning = (s) => {
    const t = s.replace(/:$/, '');
    if (!erVersaler(t)) return t;
    const lav = t.toLocaleLowerCase('nb-NO');
    return lav.charAt(0).toLocaleUpperCase('nb-NO') + lav.slice(1);
  };

  const nav = document.createElement('nav');
  nav.className = 'gs-vilkar__innhold';
  nav.setAttribute('aria-label', 'Innhold');
  const detaljer = document.createElement('details');
  const oppsummering = document.createElement('summary');
  oppsummering.textContent = `Innhold (${titler.length})`;
  const liste = document.createElement('ol');

  const lenker = [];
  titler.forEach(({ el, tekst }) => {
    if (!el.id) el.id = slug(setning(tekst));
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = `#${el.id}`;
    a.textContent = setning(tekst);
    li.appendChild(a);
    liste.appendChild(li);
    lenker.push({ a, el });
  });

  detaljer.append(oppsummering, liste);
  nav.appendChild(detaljer);

  const bred = window.matchMedia('(min-width: 990px)');
  const settApen = () => { detaljer.open = bred.matches; };
  settApen();
  bred.addEventListener('change', settApen);

  // På mobil lukkes lista når man har valgt, så teksten ikke skjules bak den.
  liste.addEventListener('click', (e) => {
    if (e.target.closest('a') && !bred.matches) detaljer.open = false;
  });

  const kropp = beholder.querySelector('.shopify-policy__body');
  kropp.insertBefore(nav, rte);
  beholder.classList.add('gs-vilkar--med-innhold');

  // Marker hvor i dokumentet man er, på skrivebord.
  if ('IntersectionObserver' in window) {
    const synlige = new Map();
    const io = new IntersectionObserver((poster) => {
      poster.forEach((p) => synlige.set(p.target, p.isIntersecting));
      const aktiv = lenker.find(({ el }) => synlige.get(el));
      if (!aktiv) return;
      lenker.forEach(({ a }) => a.removeAttribute('aria-current'));
      aktiv.a.setAttribute('aria-current', 'true');
    }, { rootMargin: '-15% 0px -70% 0px' });
    lenker.forEach(({ el }) => io.observe(el));
  }
})();
